import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import { store } from "store";
//import vueMixins from 'vue-mixins';
var HomeView = /** @class */ (function (_super) {
    tslib_1.__extends(HomeView, _super);
    function HomeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.store = store;
        return _this;
    }
    Object.defineProperty(HomeView.prototype, "selectedOrganizationEvents", {
        get: function () {
            return store.events.filter(function (e) { return e.organizationId == store.currentUser.selectedOrganizationId; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeView.prototype, "sumPerLap", {
        get: function () {
            var total = store.selectedEvent.sponsors
                .filter(function (s) { return s.paymentMethod === "PerRepeat" && s.participationStatus === "Participates"; })
                .reduce(function (totalSum, sponsor) { return totalSum + sponsor.payment; }, 0);
            if (total == 0)
                return "?";
            return total.toString();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeView.prototype, "participatingSponsorCount", {
        get: function () {
            return store.selectedEvent.sponsors
                .filter(function (s) { return s.participationStatus == "Participates" ||
                s.participationStatus == "Paid"; })
                .length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HomeView.prototype, "totalSponsorPayments", {
        get: function () {
            var total = store.selectedEvent.sponsors
                .filter(function (s) { return s.participationStatus === "Participates"; })
                .reduce(function (totalSum, sponsor) { return totalSum + sponsor.shouldPay; }, 0);
            return total;
        },
        enumerable: true,
        configurable: true
    });
    HomeView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, user, _c, err_1, billingInfoSeen, organizations, _d, events, events_1, events_1_1, e, _e, e_1_1, eventParticipants, _loop_1, eventParticipants_1, eventParticipants_1_1, ep, _f;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        this.loading = true;
                        store.page.title = this.$t("homeView.title");
                        store.page.showTopNav = false;
                        this.$router.clearHistory();
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        _c = store;
                        return [4 /*yield*/, axios.get("users/me")];
                    case 2:
                        user = _c.currentUser = (_g.sent()).data;
                        if (!store.currentUser.locale)
                            store.currentUser.locale = "fi";
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _g.sent();
                        if (err_1.response.status == 401)
                            this.$router.push("/login");
                        return [2 /*return*/];
                    case 4:
                        this.$i18n.locale = store.currentUser.locale;
                        billingInfoSeen = localStorage.getItem("billingInfoSeen");
                        if (!billingInfoSeen) {
                            localStorage.setItem("billingInfoSeen", "indeed");
                            this.store.popup.title = "";
                            this.store.popup.description = this.$t("homeView.billingInfo");
                            this.store.popup.visible = true;
                        }
                        _d = store.currentUser;
                        return [4 /*yield*/, axios.get("organizations")];
                    case 5:
                        organizations = _d.organizations = (_g.sent()).data;
                        if (store.currentUser.organizations.length === 0)
                            store.currentUser.organizations = null;
                        // pre-load previously persisted organization
                        if (user.selectedOrganizationId)
                            store.selectedOrganization = user.organizations.find(function (o) { return o.organizationId == user.selectedOrganizationId; });
                        if (!store.selectedOrganization && store.currentUser.organizations)
                            store.selectedOrganization = store.currentUser.organizations[0];
                        return [4 /*yield*/, axios.get("events", { params: { fromYear: new Date().getFullYear() } })];
                    case 6:
                        events = (_g.sent()).data;
                        if (events.length == 0)
                            events = null;
                        if (!events) return [3 /*break*/, 16];
                        _g.label = 7;
                    case 7:
                        _g.trys.push([7, 12, 13, 14]);
                        events_1 = tslib_1.__values(events), events_1_1 = events_1.next();
                        _g.label = 8;
                    case 8:
                        if (!!events_1_1.done) return [3 /*break*/, 11];
                        e = events_1_1.value;
                        _e = e;
                        return [4 /*yield*/, axios.get("sponsors", { params: { eventId: e.eventId } })];
                    case 9:
                        _e.sponsors = (_g.sent()).data
                            // do not include sponsors imported from external sources, as those are expected to be available
                            // in invitePreviousSponsorsView
                            .filter(function (s) { return !(s.participationStatus == "NotAnswered" && s.invitedOn == null); });
                        _g.label = 10;
                    case 10:
                        events_1_1 = events_1.next();
                        return [3 /*break*/, 8];
                    case 11: return [3 /*break*/, 14];
                    case 12:
                        e_1_1 = _g.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 14];
                    case 13:
                        try {
                            if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 14:
                        store.events = events;
                        store.selectedEvent = events.find(function (e) { return e.eventId == store.currentUser.selectedEventId; });
                        // Another organization was selected if the currently selected event isn't found in the
                        // events of the currently selected organization.
                        if (!store.selectedEvent ||
                            !this.selectedOrganizationEvents.find(function (e) { return e.eventId == store.selectedEvent.eventId; })) {
                            store.selectedEvent = store.events[0];
                            store.selectedOrganization = store.currentUser.organizations.find(function (o) { return o.organizationId == store.selectedEvent.organizationId; });
                        }
                        return [4 /*yield*/, axios.get("eventparticipants", { params: { fromYear: new Date().getFullYear() } })];
                    case 15:
                        eventParticipants = (_g.sent()).data;
                        _loop_1 = function (ep) {
                            var event_1 = events.find(function (e) { return e.eventId == ep.eventId; });
                            if (event_1)
                                event_1.eventParticipant = ep;
                        };
                        try {
                            for (eventParticipants_1 = tslib_1.__values(eventParticipants), eventParticipants_1_1 = eventParticipants_1.next(); !eventParticipants_1_1.done; eventParticipants_1_1 = eventParticipants_1.next()) {
                                ep = eventParticipants_1_1.value;
                                _loop_1(ep);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (eventParticipants_1_1 && !eventParticipants_1_1.done && (_b = eventParticipants_1.return)) _b.call(eventParticipants_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        _g.label = 16;
                    case 16:
                        _f = store;
                        return [4 /*yield*/, axios.get("applicationsettings/globalsettings", {
                                params: {
                                    locale: this.$i18n.locale,
                                }
                            })];
                    case 17:
                        _f.globalSettings = (_g.sent()).data;
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    HomeView.prototype.showSponsors = function () {
        this.$router.push("/sponsors");
    };
    HomeView.prototype.chooseEvent = function () {
        this.$router.push("/choose-event");
    };
    HomeView.prototype.chooseOrganization = function () {
        this.$router.push("/choose-organization");
    };
    HomeView.prototype.editLaps = function () {
        this.$router.push("/edit-laps");
    };
    HomeView.prototype.inviteSponsor = function () {
        this.$router.push("/invite-sponsor");
    };
    HomeView.prototype.permission = function () {
        this.$router.push('/permission');
    };
    HomeView.prototype.instructions = function () {
        this.$router.push('/instructions');
    };
    HomeView = tslib_1.__decorate([
        Component
    ], HomeView);
    return HomeView;
}(Vue));
export default HomeView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/HomeView.vue
// module id = 61
// module chunks = 0